import React from 'react';
import ModalV4 from '../../../../app/ui/modal/v4/v4';

import SessionCustomField from "../../../model2/custom-field/session-custom-field";
import {getTaskCustomFieldByType} from "../../../fields/custom-field-factory";
import ModalCustomField_EditFieldV3 from "../custom-field/edit/edit-field-v3";
import ModalCustomField_EditFieldV1 from "../custom-field/edit/edit-field-v1";

type Props = {
    params          : {
        customFieldId   : ID
        callback?       : callback
    }
}

// const debug = "CustomFieldsModal"
const debug = false

export default class ModalEditCustomField extends ModalV4 {

    constructor(props:Props) {
        super(props);
    }

    render() {

        debug && console.log(debug, "render() props=", this.props)

        const customField : SessionCustomField =  gd.session.customFields.get(this.props.params.customFieldId)!

        const field = getTaskCustomFieldByType(customField.type, customField);

        if (field.version === 3) {
            return <ModalCustomField_EditFieldV3 field = {field}
                                                 customField = {customField}
                                                 onCloseClick = {this.closeModal}
                                                 callback = {this.props.params.callback}
            />;

        } else {

            return <ModalCustomField_EditFieldV1 field = {field}
                                                 customField = {customField}
                                                 onCloseClick = {this.closeModal}
                                                 callback = {this.props.params.callback}
            />;

            // return <ModalCustomField_Step2Form isNew={false}
            //                                    type={customField.type}
            //                                    params={this.props.params}
            //                                    onCloseClick={this.closeModal}
            //                                    onSubmit={this.onSubmit}
            //                                    onBackToStep1={()=>{}}
            // />;
        }
    }
}
